import Vue from 'vue'

import alertHelper from '@/helpers/alerts'
import swalHelper from '@/helpers/swal'
import momentHelper from '@/helpers/moments'
import contactHelper from '@/helpers/contacts'
import valueHelper from '@/helpers/values'
import stringHelper from '@/helpers/string'
import componentHelper from '@/helpers/component'
import errorHelper from '@/helpers/errors'
import assetHelper from '@/helpers/asset'
import dateTimeHelper from '@/helpers/dateTime'
import queueHelper from '@/helpers/queue'
import windowOpenerHelper from '@/helpers/windowOpener'

const VuePlugins = {
  install (Vue, options) {
    Vue.windowOpenerHelper = windowOpenerHelper
    Vue.prototype.$windowOpenerHelper = windowOpenerHelper

    Vue.alertHelper = alertHelper
    Vue.prototype.$alertHelper = alertHelper

    Vue.swalHelper = swalHelper
    Vue.prototype.$swalHelper = swalHelper

    Vue.momentHelper = momentHelper
    Vue.prototype.$momentHelper = momentHelper

    Vue.contactHelper = contactHelper
    Vue.prototype.$contactHelper = contactHelper

    Vue.valueHelper = valueHelper
    Vue.prototype.$valueHelper = valueHelper

    Vue.stringHelper = stringHelper
    Vue.prototype.$stringHelper = stringHelper

    Vue.componentHelper = componentHelper
    Vue.prototype.$componentHelper = componentHelper

    Vue.errorHelper = errorHelper
    Vue.prototype.$errorHelper = errorHelper

    Vue.assetHelper = assetHelper
    Vue.prototype.$assetHelper = assetHelper

    Vue.assetHelper = assetHelper
    Vue.prototype.$assetHelper = assetHelper

    Vue.dateTimeHelper = dateTimeHelper
    Vue.prototype.$dateTimeHelper = dateTimeHelper

    Vue.queueHelper = queueHelper
    Vue.prototype.$queueHelper = queueHelper
  }
}

Vue.use(VuePlugins)
